<template>
  <div class="modal-card" style="width: auto">
    <b-loading
      :is-full-page="true"
      :active="isLoading"
      :can-cancel="false"
    ></b-loading>
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">
        {{ $t("account.languageHeader") }}
      </p>
    </header>

    <section class="modal-card-body">
      <button class="button flag-button" @click="setLanguage('pt_BR')">
        <div style="display: inline">
          <span class="flag-icon flag-icon-br"></span>
        </div>
        <span style="color: black"
          >&nbsp;&nbsp;{{ $t("account.accountLanguagePT-BR") }}</span
        >
      </button>
      <br />

      <button class="button flag-button" @click="setLanguage('pt_PT')">
        <div style="display: inline">
          <span class="flag-icon flag-icon-pt"></span>
        </div>
        <span style="color: black"
          >&nbsp;&nbsp;{{ $t("account.accountLanguagePT-PT") }}</span
        >
      </button>
      <br />

      <button class="button flag-button" @click="setLanguage('en')">
        <div style="display: inline;">
          <span class="flag-icon flag-icon-gb"></span>
        </div>
        <span style="color: black"
          >&nbsp;&nbsp;
          {{ $t("account.accountLanguageEN") }}
        </span>
      </button>
      <br />

      <button class="button flag-button" @click="setLanguage('es')">
        <div style="display: inline">
          <span class="flag-icon flag-icon-es"></span>
        </div>
        <span style="color: black"
          >&nbsp;&nbsp;
          {{ $t("account.accountLanguageES") }}
        </span>
      </button>
    </section>

    <footer class="modal-card-foot" style="justify-content: space-evenly">
      <button class="button" type="button" @click="$parent.close()">
        {{ $t("common.cancel") }}
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { common } from "../../mixins/common.js";

export default {
  mixins: [common],

  data() {
    return {
      isLoading: false
    };
  },

  computed: {
    ...mapGetters(["locale"])
  },

  methods: {
    setLocale(l) {
      this.isLoading = true;
      this.$store
        .dispatch("setLocale", l)
        .then(res => {
          if (res.data.result === "ok") {
            this.isLoading = false;
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setLanguage(language) {
      this.setLocale(language);
      this.$parent.close();
    }
  }
};
</script>

<style scoped>
.modal-card-body {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.flag-icon {
  width: 2rem;
  height: 2rem;
}
.flag-button {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-top: 25px;
  padding-bottom: 25px;
  width: 225px;
}
@media (max-width: 600px) {
  .flag-button {
    padding-top: 12px;
    padding-bottom: 12px;
  }
}
</style>
